module.exports = __webpack_public_path__ + "img/you.49e69941.png";